let obj = {};
obj.companyIdTypeOptions = [
    {
        value: "1",
        name: "身份证",
    },
    {
        value: "03",
        name: "统一社会信用代码",
    }
]
//计划
obj.plansValues = [
    {
        name: '计划一',
        value: 'HAZXB1',
        money1: '100万',
        money2: '100万',
        money3: '50万',
        money4: '50万'
    }, {
        name: '计划二',
        value: 'HAZXB2',
        money1: '200万',
        money2: '200万',
        money3: '100万',
        money4: '100万'
    }, {
        name: '计划三',
        value: 'HAZXB3',
        money1: '300万',
        money2: '300万',
        money3: '100万',
        money4: '150万'
    }, {
        name: '计划四',
        value: 'HAZXB4',
        money1: '500万',
        money2: '500万',
        money3: '100万',
        money4: '300万'
    }, {
        name: '计划五',
        value: 'HAZXB5',
        money1: '1000万',
        money2: '500万',
        money3: '100万',
        money4: '300万'
    }, {
        name: '计划六',
        value: 'HAZXB6',
        money1: '2000万',
        money2: '500万',
        money3: '100万',
        money4: '300万'
    }
]
obj.deshOptions = [
    {
        name: '不附加',
        value: 0
    },
    {
        name: '限额一',
        value: 1,
        money1: '120万',
        money2: '10万',
        money3: '1万'
    }, {
        name: '限额二',
        value: 2,
        money1: '120万',
        money2: '20万',
        money3: '2万'
    }, {
        name: '限额三',
        value: 3,
        money1: '120万',
        money2: '30万',
        money3: '3万'
    }, {
        name: '限额四',
        value: 4,
        money1: '120万',
        money2: '50万',
        money3: '5万'
    }, {
        name: '限额五',
        value: 5,
        money1: '200万',
        money2: '100万',
        money3: '10万'
    }
]
//客户性质
obj.customerQuality = [
    { name: '法人', value: '01' }
]
//施工资质
obj.constructionNature = [
    { name: '特级', value: '3' },
    { name: '一级', value: '1' },
    { name: '二级', value: '2' },
    { name: '三级', value: '4' },
]
//施工类型
obj.constructionType = [
    { name: '室内装修工程（无室外）', value: '1' }
]
//关联投保人column
obj.columns = [
    { title: '序列号', dataIndex: 'idx', key: 'idx', align: 'center', scopedSlots: { customRender: 'idx' } },
    {
        title: '企业名称', dataIndex: 'companyName', key: 'companyName', align: 'center',
        scopedSlots: { customRender: 'companyName' }
    },
    {
        title: '操作', dataIndex: 'operation', key: 'operation', align: 'center',
        scopedSlots: { customRender: 'operation' }
    }
]

export default { ...obj }